import { React, useLayoutEffect } from "react";
import "boxicons";
import "../css/Home.css";
import Footer from "./Footer";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";

import $ from 'jquery';
import ivf from "../images/ivf.jpg";
import iui from "../images/iui-treatment.jpg";
import icsi from "../images/icsi.jpg";
// import egg from "../images/egg.jpg";
// import spr from "../images/sperm-ret.jpg";
import freez from "../images/freezing.jpg";
import surro from "../images/surrogacy.jpg";
import banner from "../images/banner1.jpg";
import b1 from "../images/banner2.jpg";
import b2 from "../images/banner3.jpg";
import b4 from "../images/gynaec-banner.jpg";
import b5 from "../images/dermat-banner.jpg";
import lab1 from "../images/clinic/admit-room1.jpg";
import lab2 from "../images/clinic/admit-room2.jpg";
import lab3 from "../images/clinic/admit-room3.jpg";
import lab4 from "../images/clinic/admit-room4.jpg";
import lab5 from "../images/clinic/collect-room1.jpg";
import lab6 from "../images/clinic/collection-room3.jpg";
import lab7 from "../images/clinic/collect-room2.jpg";
import lab8 from "../images/clinic/collect-room1.jpg";

import son1 from "../images/clinic/opd.jpg";
import son2 from "../images/clinic/opd1.jpg";
import son3 from "../images/clinic/opd-2.1.jpg";
import son4 from "../images/clinic/opd-2.jpg";
import son5 from "../images/clinic/opd3.jpg";
import son6 from "../images/clinic/opd4.jpg";
import son7 from "../images/clinic/sonography-room.jpg";
import son8 from "../images/clinic/collect-room1.jpg";
import consult1 from "../images/clinic/consult-room.jpg";
import consult2 from "../images/clinic/consult-room2.jpg";
import consult3 from "../images/clinic/IMG_2249.JPG";
import consult4 from "../images/clinic/IMG_2260.JPG";

import lab9 from "../images/clinic/machine.jpg";
import lab10 from "../images/clinic/machine2.jpg";
import lab11 from "../images/clinic/machine3.jpg";
import lab12 from "../images/clinic/machine-4.jpg";
import lab13 from "../images/clinic/sudhir-lab.jpg";
import lab14 from "../images/clinic/sudhir-lab2.jpg";
import lab15 from "../images/clinic/sudhir-lab3.jpg";
import lab16 from "../images/clinic/savita-lab1.jpg";
import lab17 from "../images/clinic/savita-lab2.jpg";
import lab18 from "../images/clinic/savita-lab3.jpg";
import lab19 from "../images/clinic/diagnos-machine.jpg";
import lab20 from "../images/dermat-banner.jpg";

import Service from "./Service";
import clinic1 from "../images/clinic/IMG_2344.JPG";
import Zoom from "react-reveal/Zoom";
import Fade from "react-reveal/Fade";
import { Link } from "react-router-dom";
// import Swiper from 'swiper'
// import {Power1} from 'gsap'
// import gsap from 'gsap'

import { Navigation } from "swiper";
import { Autoplay } from "swiper";
import TreatmentData from "./TreatmentData";
// import { Pagination } from "swiper";
const Home = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  });
  const formSubmit = () => {
    var custName;
    var custEmail;
    var custPhone;
    var custAge;
    var custMessage;

    if ($(".custName").val() !== "") {
      custName = $(".custName").val();
    } else {
    }
    if ($(".custPhone").val() !== "") {
      custPhone = $(".custPhone").val();
    } else {
    }
    if ($(".custAge").val() !== "") {
      custAge = $(".custAge").val();
    } else {
    }
    if ($(".custEmail").val() !== "") {
      custEmail = $(".custEmail").val();
    } else {
    }

    if ($(".custMessage").val() !== "") {
      custMessage = $(".custMessage").val();
    } else {
    }
    
    var body =
      '<!DOCTYPE html><html><head><title>Enclave Healthcare</title><meta http-equiv="Content-Type" content="text/html; charset=utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><meta http-equiv="X-UA-Compatible" content="IE=edge"></head><body style="margin:0!important;padding:0!important;background-color:#eee" bgcolor="#eeeeee"><div style="display:none;font-size:1px;color:#fefefe;line-height:1px;font-family:Open Sans,Helvetica,Arial,sans-serif;max-height:0;max-width:0;opacity:0;overflow:hidden"></div><table border="0" cellpadding="0" cellspacing="0" width="100%" bgcolor="#fff"><tr><td align="center" style="background-color:#eee" bgcolor="#eeeeee"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"><tr><td align="center" valign="top" style="font-size:0;padding:10px" bgcolor="#164388"><div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"><tr><td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:6px;font-weight:800;line-height:10px" class="mobile-center"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"><tr><td width="100%" align="center" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:800;line-height:24px;padding:10px"><a href="tel:+91" style="text-decoration:none;color:#fff;font-family:serif;font-size:16px">Leade Generate for Enclave Healthcare</a></td></tr></table></td></tr></table></div></td></tr><tr><td align="center" valign="top" style="font-size:0;padding:15px" bgcolor="#fff"><div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;display:fle;justify-content:center;align-items:center;width:100%"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"><tr><td align="center" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:36px;font-weight:800;line-height:48px" class="mobile-center"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"><tr><td width="100%" align="center" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-weight:800"><img style="width:120px;height:120px" src="" alt=""></td></tr></table></td></tr></table></div></td></tr><tr><td align="center" valign="top" style="font-size:0;padding:0" bgcolor="#164388"><div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;display:fle;justify-content:center;align-items:center;width:100%"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"><tr><td width="100%" align="center" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:800;padding:10px 0" class="mobile-center"><h1 style="text-transform:capitalize;font-size:14px;font-weight:500;margin:0;text-align:center;color:#fff">Client Enquiry Details</h1></td></tr></table></div></td></tr><tr><td align="center" height="100%" valign="top" width="100%" style="padding:0 35px 35px 35px;background-color:#fff" bgcolor="#eee"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:660px"><tr><td width="100%" align="center" valign="top" style="font-size:0"><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;text-align:center;width:100%"><table width="100%" align="center" border="0" cellpadding="0" cellspacing="0" style="max-width:300px"><tr><td width="100%" align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#164388">Customer Name:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custName +
      '</p></td></tr></table></div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"><tr><td width="100%" align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#164388">Customer Number:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custPhone +
      '</p></td></tr></table></div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"><tr><td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#164388">Customer Email:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custEmail +
      '</p></td></tr></table></div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"><tr><td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#164388">Customer Age:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custAge +
      '</p></td></tr></table></div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"><tr><td width="100%" align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#164388">Customer Message:</p><p style="font-size:14px;font-weight:500;color:#111">' +
    
      custMessage +
      '</p></td></tr></table></div></td></tr></table></td></tr><tr><td width="100%" align="center" bgcolor="#164388" style="padding:10px 0"><p style="color:#fff;font-weight:500;font-size:1rem;padding:0;margin:0">© Copyright 2022 Enclave Healthcare</p></td></tr></table></td></tr></table></body></html>';

    $.post(
      "https://skdm.in/server/v1/send_lead_mail.php",
      {
        toEmail: "enclavehealthcare@gmail.com",
        fromEmail: "skdmlead@gmail.com",
        bccMail: "skdmlead@gmail.com",
        mailSubject: "New Lead genration",
        mailBody: body,
        accountName: "enclavehealthcare",
        accountLeadSource: "https://enclavehealthcare.com/",
        accountLeadName: custName,
        accountLeadPhone: custPhone,
        accountLeadEmail: custEmail,
        accountLeadMsgs: custMessage,
      },

      function (dataa, status) {
        console.log("data :" + dataa);
        console.log("name:" + custName);
      }
    );

    alert("Your Form has Submited Our team will contact with You  soon.");

    window.location.reload();

    return false;
  };
 
  return (
    <>
<title>Fertility Hospital in Goregaon | Enclave Healthcare </title>
<meta http-equiv="cache-control" content="no-cache" />
      <meta http-equiv="expires" content="0" />
      <meta http-equiv="pragma" content="no-cache" />
      <meta
        property="title"
        content="Fertility Hospital in Goregaon | Enclave Healthcare"
      />
      <meta
        property="og:title"
        content="Fertility Hospital in Goregaon | Enclave Healthcare"
      />
      <meta
        property="description"
        content="Enclave Healthcare is a top Fertility Hospital in Goregaon. Embark on your journey to parenthood with confidence – schedule a consultation today.
        "
      />
      <meta
        property="og:description"
        content="Enclave Healthcare is a top Fertility Hospital in Goregaon. Embark on your journey to parenthood with confidence – schedule a consultation today.
        "
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="http://enclavehealthcare.com/" />
      <meta property="article:tag" content="Fertility Hospital in Goregaon" />
      <meta property="article:tag" content="Best Fertility Hospital in Goregaon" />
      <meta property="article:tag" content="best ivf hospital in mumbai" />
      <meta property="article:tag" content="Fertility Care in Goregaon" />
      <meta property="article:tag"  content="Best IVF Center in Goregaon"
      />
      <meta property="article:tag" content="Best Fertility Doctor in Goregaon" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="theme-color" content="#000000" />
   
    <meta
    name="keywords"
    content="Fertility Hospital in Goregaon,
    Best Fertility Hospital in Goregaon,
    Fertility Care in Goregaon,
    Best IVF Center in Goregaon,
    Best Fertility Doctor in Goregaon,
    Top Fertility Care in Goregaon,
    Top IUI Center in Goregaon
    Best IVF Care in Goregaon,
    Gynecologist in Goregaon,
    Best Doctor for Fertility in Goregaon ,
    Best Pediatrician in Goregaon,
    Best Obstetricians and Gynecologists in Goregaon,
    IVF with Egg Freezing Hospitals in Goregaon"
  />
 
    <link rel="canonical" href="http://enclavehealthcare.com/"/>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        // navigation={true}
        modules={[Autoplay]}
        className="mySwiper"
      >
        <SwiperSlide>
          <div className="banner" id="thirdSlide">
            <img src={b2} alt="test tube baby"/>
            {/* <div className="tagline">
            <Zoom left cascade>
              <h2>We live and breathe fertility solutions</h2>
              <p> Lorem Ipsum is simply text of the printing and typesetting
                    industry. consectetur adipiscing elit.</p>
                    </Zoom>
             </div> */}
          </div>
          {/* <img src={b2} /> */}
        </SwiperSlide>
        <SwiperSlide>
          <div className="banner" id="firstSlide">
            <img src={banner} alt="infertility"/>
            {/* <div className="tagline">
            <Zoom left cascade>
              <h2>The advocacy of providing happiness to couples continues</h2>
              <p>
                {" "}
                Lorem Ipsum is simply text of the printing and typesetting
                industry. consectetur adipiscing elit.
              </p>
              </Zoom>
            </div> */}
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="banner" id="secondSlide">
            <img src={b4} alt="obstretics and gynaecology"/>
            {/* <div className="tagline">
              <Zoom left cascade>
                <h2>We live and breathe fertility solutions</h2>
                <p>
                  Lorem Ipsum is simply text of the printing and typesetting
                  industry. consectetur adipiscing elit.
                </p>
              </Zoom>
            </div> */}
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="banner" id="secondSlide">
            <img src={b5} alt="fertility-hospital-goregaon"/>
            {/* <div className="tagline">
              <Zoom left cascade>
                <h2>We live and breathe fertility solutions</h2>
                <p>
                  Lorem Ipsum is simply text of the printing and typesetting
                  industry. consectetur adipiscing elit.
                </p>
              </Zoom>
            </div> */}
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="banner" id="secondSlide">
            <img src={b1} alt="IVF canter"/>
            {/* <div className="tagline">
              <Zoom left cascade>
                <h2>We live and breathe fertility solutions</h2>
                <p>
                  Lorem Ipsum is simply text of the printing and typesetting
                  industry. consectetur adipiscing elit.
                </p>
              </Zoom>
            </div> */}
          </div>
        </SwiperSlide>

        {/* <SwiperSlide>Slide 4</SwiperSlide>
        <SwiperSlide>Slide 5</SwiperSlide>
        <SwiperSlide>Slide 6</SwiperSlide>
        <SwiperSlide>Slide 7</SwiperSlide>
        <SwiperSlide>Slide 8</SwiperSlide>
        <SwiperSlide>Slide 9</SwiperSlide> */}
      </Swiper>




{/* --------------------------------------------gallery--------------------- */}
<section>
        <div className="container">
          <div className="heading-subheading text-center reverse-heading-yes">
          <h1 className="title">Fertility Hospital in Goregaon</h1>
            <h2 className="subtitle">Gallery</h2>
            {/* <h2 className="title">World Class Infrastructure</h2> */}
          </div>
          <div className="row">
          <div className="col-lg-3 col-md-6 col-12 mb-lg-5 mb-2">
            <Swiper
              navigation={true}
              breakpoints={{
                570: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                },
                640: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                },
                768: {
                  slidesPerView: 1,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 1,
                  spaceBetween: 50,
                },
              }}
              modules={[Navigation]}
              className="mySwiper1"
            >
             
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={consult1} alt="Fertility Hospital in Goregaon" />
                  
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={consult2} alt="Fertility Hospital in Goregaon" />
                   
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={consult3} alt="Fertility Hospital in Goregaon" />
                  
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={consult4} alt="Fertility Hospital in Goregaon" />
                  
                  </div>
                </div>
                </SwiperSlide>
            </Swiper>
            </div>
            <div className="col-lg-3 col-md-6 col-12 mb-lg-5 mb-2">
            <Swiper
              navigation={true}
              breakpoints={{
                570: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                },
                640: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                },
                768: {
                  slidesPerView: 1,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 1,
                  spaceBetween: 50,
                },
              }}
              modules={[Navigation]}
              className="mySwiper1"
            >
             
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={lab1} alt="Fertility Hospital" />
                   
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={lab2} alt=" Hospital in Goregaon"/>
                  
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={lab3} alt="Fertility Hospital in Goregaon" />
                   
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={lab4} alt="Fertility Hospital in Goregaon" />
                   
                  </div>
                </div>
              </SwiperSlide>
            
            </Swiper>
            </div>
            <div className="col-lg-3 col-md-6 col-12 mb-lg-5 mb-2">
            <Swiper
              navigation={true}
              breakpoints={{
                570: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                },
                640: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                },
                768: {
                  slidesPerView: 1,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 1,
                  spaceBetween: 50,
                },
              }}
              modules={[Navigation]}
              className="mySwiper1"
            >
                <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={son1} alt="Fertility Hospital in Goregaon" />
                   
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={son2} alt="Fertility Hospital in Goregaon
                    " />
                   
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={son3} alt="Fertility Hospital in Goregaon" />
                   
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={son4} alt="Fertility Hospital in Goregaon" />
                   
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={son5} alt="Fertility Hospital in Goregaon" />
                   
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={son6} alt="Fertility Hospital in Goregaon" />
                   
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={son7} alt="Fertility Hospital in Goregaon" />
                   
                  </div>
                </div>
              </SwiperSlide>
             
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={son8} alt="Fertility Hospital in Goregaon
                    " />
                   
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={lab6} alt="Fertility Hospital in Goregaon" />
                  
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={lab7} alt="Fertility Hospital in Goregaon" />
                   
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={lab8} alt="Fertility Hospital in Goregaon" />
                   
                  </div>
                </div>
              </SwiperSlide>
             
            </Swiper>
            </div>
            <div className="col-lg-3 col-md-6 col-12 mb-lg-5 mb-2">
            <Swiper
              navigation={true}
              breakpoints={{
                570: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                },
                640: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                },
                768: {
                  slidesPerView: 1,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 1,
                  spaceBetween: 50,
                },
              }}
              modules={[Navigation]}
              className="mySwiper1"
            >
             
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={lab9} alt="Fertility Hospital in Goregaon" />
                   
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={lab10} alt="best gynaecology center in goregaon" />
                  
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={lab11} alt="best dermatology center in mmbai" />
                   
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={lab12} alt="best pediatric center in mmbai" />
                   
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={lab13} alt="best dermatology center in mumbai" />
                   
                  </div>
                </div>
                </SwiperSlide>
                <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={lab14} alt="best pediatric center in mumbai" />
                   
                  </div>
                </div>
                </SwiperSlide>
                <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={lab15} alt=" best fertility center in mumbai" />
                   
                  </div>
                </div>
                </SwiperSlide>
                <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={lab16} alt="best women and child care" />
                   
                  </div>
                </div>
                </SwiperSlide>
                <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={lab17} alt="best child care in malad" />
                   
                  </div>
                </div>
                </SwiperSlide>
                <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={lab18} alt="best pregnancy treatment" />
                   
                  </div>
                </div>
                </SwiperSlide>
                <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={lab19} alt=" pregnancy delivery" />
                   
                  </div>
                </div>
                </SwiperSlide>
            </Swiper>
            </div>
          </div>
         
        </div>
      </section>
{/* ------------------------------------------------services------------------ */}
      <section id="services" className="services">
        <div className="container aos-init aos-animate" data-aos="fade-up">
          <div className="ele-header-area">
            <Zoom left cascade>
              <div className="heading-subheading text-center reverse-heading-yes">
                <h1 className="subtitle">Services We Provide</h1>
                <p>
                At Enclave Healthcare we provide various services for Fertility, IVF , Maternity, Gynaecology, Pediatric,Dermatology and speciality care. 
                </p>
              </div>
            </Zoom>
          </div>

          <div className="row">
            {Service.map((elem) => {
              const { ServiceIcon,  Slugs,ServiceName, ServicePara1 } = elem;
              return (
                <>
                  <div
                    className="col-lg-4 col-md-6 icon-box aos-init aos-animate"
                    data-aos="zoom-in"
                    data-aos-delay="100"
                  >
                    <div className="icon">
                      <img src={ServiceIcon} />
                    </div>
                    <h4 className="title">
                  {ServiceName}
                    </h4>
                    <p className="description">{ServicePara1}</p>
                  </div>
                </>
              );
            })}
           
          </div>
        </div>
      </section>

      {/* ---------------------------------about section-------------------- */}
      <section className="about-section pb-lg-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-md-6 col-12 wow fadeInLeft mb-30">
              <div className="heading-subheading my-4">
                <Fade left big>
                  <h4 className="subtitle">About us</h4>
                  <h2 className="title">
                    25+ Years of Excellence in Women and Child Care
                  </h2>
                </Fade>
                <p>
                Welcome to the fertility hospital and Pediatric Healthcare in goregaon. Strength and growth comes only through continuous efforts and struggle. -Napoleon Hill This philosophy has epitomized the practice of Dr Sudhir Naik and Dr Savita Naik for the last 25 years. Their motto of enhancing life by excelling in healthcare was the key to the birth of “Enclave healthcare” an ultramodern OPD complex with a state of the art IVF-Fertility center.


               </p>
                <br />
                <p>
                The fertility hospital in goregaon’s focus has been Women and Child health. IVF Fertility Centre and Pediatric Healthcare. It offers Fertility/ IVF services along with Obstetrics and Gynaecology, adolescent and menopausal care services to women. With Dr Savita Naik a highly experienced Pediatrician and Neonatologist at the helm it offers Pediatric consultations, immunization and well baby care services too. A dermatology department with facilities for laser skin treatment is part of the Speciality care provided.

 
                </p>
                <br />
                <p>
                  Dr. Pratik S. Naik is a highly experienced Consultant Obstetrician, Gynecologist, Laparoscopic Surgeon, and IVF Specialist, dedicated to providing compassionate and advanced women’s healthcare. With strong academic credentials including MS, DNB, F.MAS, F.IVF.ART, he offers expert care across pregnancy, gynecology, fertility treatments, and minimally invasive surgeries. Practicing at Oyster Hospital, Goregaon (W), Mumbai, Dr. Naik combines modern medical technology with a patient-first approach to ensure safe, personalized, and effective treatment for every stage of a woman’s health journey.
                </p>
              </div>
            </div>
            <div
              className="col-lg-5 col-md-6 col-12 wow fadeInRight"
              data-wow-delay="200ms"
              style={{
                visibility: "visible",
                animationDelay: "200ms",
                animationName: "fadeInRight",
              }}
            >
              <div className="about-bottom">
                {/* <img
                  src="assets/images/signature-img.png"
                  alt=" "
                  className="image about-signature"
                /> */}
              </div>
              <div className="about-img">
                <img src={clinic1} alt="Enclave healthcare multispeciality hospital" />
                <div className="about-img-hotifer">
                  <p>25+ Years of Excellence in Women and Child Care.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --------------------------facility------------------------- */}
      <section className="features">
        <div className="container">
          <div className="row features-items">
            <div
              className="col-lg-3 col-md-6 col-12"
              data-wow-delay="300ms"
              style={{
                visibility: "visible",
                animationDelay: "300ms",
                animationName: "fadeInUp",
              }}
            >
              <div className="feature__card three">
                <div className="feature__icon">
                  <i className="fa fa-desktop" />
                </div>
                <Zoom>
                  <div className="feature__content">
                    <h3>video consultancy</h3>
                    <p>
                      Book Video Consultancy:- <br />
                      <b>
                        Dr. Savita Naik-
                        <br /> 91 9702310570
                      </b>
                    </p>
                    <div className="con_icon">
                      <a href="tel:+91 9702310570">
                        <i className="fa fa-phone"></i>
                      </a>
                      <a href="mailto:enclavehealthcare@gmail.com">
                        <i className="fa fa-envelope"></i>
                      </a>
                      <a href="https://wa.me/9702310570">
                        {" "}
                        <i className="fa fa-whatsapp"></i>
                      </a>
                    </div>
                  </div>
                </Zoom>
              </div>
            </div>
            <div
              className="col-lg-3 col-md-6 col-12"
              data-wow-delay="100ms"
              style={{
                visibility: "visible",
                animationDelay: "100ms",
                animationName: "fadeInUp",
              }}
            >
              <div className="feature__card one">
                <div className="feature__icon">
                  <i className="fa fa-user" />
                </div>
                <Zoom>
                  <div className="feature__content">
                    <h3>Book appointment</h3>
                    <p>
                      <b>Dr. Sudhir Naik:-</b>
                      <br />
                      8692031167
                    </p>
                    <p>
                      <b>Dr. Savita Naik</b>
                      <br />
                      9619140797
                    </p>
                    <div className="con_icon">
                      <a href="tel:+91 9619140797">
                        <i className="fa fa-phone"></i>
                      </a>
                      <a href="mailto:enclavehealthcare@gmail.com">
                        {" "}
                        <i className="fa fa-envelope"></i>
                      </a>

                      <a href="https://wa.me/9619140797">
                        {" "}
                        <i className="fa fa-whatsapp"></i>
                      </a>
                    </div>
                  </div>
                </Zoom>
              </div>
            </div>
            <div
              className="col-lg-3 col-md-6 col-12"
              data-wow-delay="200ms"
              style={{
                visibility: "visible",
                animationDelay: "200ms",
                animationName: "fadeInUp",
              }}
            >
              <div className="feature__card two">
                <div className="feature__icon">
                  <i className="fa fa-plus" />{" "}
                </div>
                <Zoom>
                  <div className="feature__content">
                    <h3>Emergency</h3>
                    <p>We are available for you from 10am to 10pm</p>
                    <p>
                      <b>9136234368</b>
                    </p>
                    <div className="con_icon">
                    <a href="tel:+91 9136234368"><i className="fa fa-phone"></i></a>  
                  <a href="mailto:enclavehealthcare@gmail.com"> <i className="fa fa-envelope"></i></a>

                  <a href="https://wa.me/9136234368"> <i className="fa fa-whatsapp"></i></a>
                    </div>
                  </div>
                </Zoom>
              </div>
            </div>

            <div
              className="col-lg-3 col-md-6 col-12"
              data-wow-delay="100ms"
              style={{
                visibility: "visible",
                animationDelay: "100ms",
                animationName: "fadeInUp",
              }}
            >
              <div className="feature__card one">
                <div className="feature__icon">
                  <i className="fa fa-user" />
                </div>
                <Zoom>
                  <div className="feature__content">
                    <h3>IVF Appointment</h3>

                    <p>
                      <b>
                        Dr. Sudhir Naik:- <br />
                        8692031167
                      </b>
                    </p>
                    <div className="con_icon">
                      <a href="tel:+91 8692031167">
                        <i className="fa fa-phone"></i>
                      </a>
                      <a href="mailto:enclavehealthcare@gmail.com">
                        {" "}
                        <i className="fa fa-envelope"></i>
                      </a>

                      <a href="https://wa.me/8692031167">
                        {" "}
                        <i className="fa fa-whatsapp"></i>
                      </a>
                    </div>
                  </div>
                </Zoom>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------------------------------why choose us-------------------------- */}
      <section className="our-features pt-lg-5 pt-2">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-6 text-sm-center text-lg-start wow fadeInLeft"
              data-wow-delay="200ms"
              style={{
                visibility: "visible",
                animationDelay: "200ms",
                animationName: "fadeInLeft",
              }}
            >
              <Zoom left cascade>
                <div className="heading-subheading">
                  <h4 className="subtitle">Why Choose Us</h4>
                  <h2 className="title">
                    ENCLAVE HEALTHCARE <br />
                    Enhancing Life, Excelling in Care.
                  </h2>
                  <p>
                    Enclave Healthcare is the latest initiative by Dr Sudhir
                    Naik and <br/> Dr Savita Naik to provide best in class Fertility,
                    IVF, Obstetric & Gynaecology Pediatric and Specialty
                    services.
                  </p>
                  <p>
                    We constantly strive to maintain the highest standards of
                    professional ethics in every thing we do
                  </p>
                </div>
              </Zoom>
            </div>
            {/* <div
        className="col-lg-6 wow fadeInRight"
        data-wow-delay="200ms"
        style={{
          visibility: "visible",
          animationDelay: "200ms",
          animationName: "fadeInRight"
        }}
      > */}

            <div className="col-lg-6 ">
              <div className="row mt-30">
                <div className="col-md-6">
                  <ul className="feature__list">
                    <li>
                      <i className="fa fa-users" /> Highly experienced team
                    </li>
                    {/* <li>
                      <Zoom left>
                        <i className="fa fa-check" />
                        wide range treatment
                      </Zoom>
                    </li> */}
                    <li>
                      <Zoom left>
                        <i className="fa fa-thumbs-up" /> State of art equipment
                      </Zoom>
                    </li>

                    <li>
                      <Zoom left>
                        <i className="fa fa-bed" />
                        Complete care and support
                      </Zoom>
                    </li>
                  </ul>
                </div>
                <div className="col-md-6 mb-40">
                  <ul className="feature__list">
                    <li>
                      <Zoom left>
                        <i className="fa fa-medkit" /> Best in class treatment
                      </Zoom>
                    </li>
                    <li>
                      <i className="fa fa-user-md" />
                      Compasionate and caring
                    </li>

                    <li>
                      <i className="fa fa-ambulance" /> Emergency help provided
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-color-blackish appointment section-lg parallaxie pt-lg-5 pt-2 pb-lg-5 pb-2">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-5 col-sm-12 wow fadeInLeft"
              data-wow-delay="200ms"
              style={{
                visibility: "visible",
                animationDelay: "200ms",
                animationName: "fadeInLeft",
              }}
            >
              <Zoom left cascade>
                <div className="heading-subheading my-4">
                  <h4 className="subtitle">Make An Appointment</h4>
                  <h2 className="title text-light">
                    We are available for you from 10AM to 10PM
                  </h2>
                </div>
              </Zoom>
              <p className="mb-20 desc">
                Our  helpline number is available  to help you in
                requirement.
              </p>
              <div className="connect_block align-items-center mb-40">
                <a href="javascript:void(0)">
                  <div className="icon_fld-nx v-center">
                    <i className="fa fa-envelope" />
                  </div>
                  <Fade left cascade>
                    <div className="txt_fld-nx v-center">
                      <span className="small-text">
                        mail to professional doctors
                      </span>
                      
                      <span className="large-text">
                        enclavehealthcare@gmail.com
                      </span>
                    </div>
                  </Fade>
                </a>
              </div>
              <div className="connect_block align-items-center mb-40">
                <a href="javascript:void(0)">
                  <div className="icon_fld-nx v-center">
                    <i className="fa fa-phone" />
                  </div>
                  <Fade left cascade>
                    <div className="txt_fld-nx v-center">
                      <span className="small-text">
                        call Enclave
                      </span>
                      <a href="tel:+919619140797"><span className="large-text">9619140797</span></a>
                    </div>
                  </Fade>
                </a>
              </div>
            </div>
            <div
              className="col-lg-7 col-sm-12 wow fadeInRight"
              data-wow-delay="200ms"
              style={{
                visibility: "visible",
                animationDelay: "200ms",
                animationName: "fadeInRight",
              }}
            >
              <Fade>
                <div className="appointment-box">
                  <h3 className="text-center mb-30">Book An Appointment</h3>
                  <form
                    // action="php/ajax_sendmail.php"
                    name="contactus"
                    method="post"
                    id="contact-form"
                  >
                    <div className="row mb-3 g-3">
                      <div className="col-lg-6 col-md-6">
                        <div className="form-group appoint__item name_field">
                          <input
                            type="text"
                            name="name"
                            className="form-control custName"
                            placeholder="Name"
                          />
                          <span className="error_msg custNameValid" id="name_error" />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="form-group appoint__item email_field">
                          <input
                            type="email"
                            name="email"
                            className="form-control custEmail"
                            placeholder="Email "
                          />
                          <span className="error_msg" id="email_error" />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="form-group appoint__item phn_field">
                          <input
                            type="tel"
                            name="phone"
                            className="form-control custPhone"
                            pattern="[0-9\-]*"
                            placeholder="Phone Number"
                          />
                          <span className="error_msg custNumberValid" id="phone_error" />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="form-group appoint__item email_field">
                          <input
                            type="number"
                            name="age"
                            className="form-control custAge"
                            placeholder="Age"
                          />
                          <span className="error_msg" id="email_error" />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        
                         
                          <select name="subject" className="nice-select" id="list" >
                            Select Doctors
                            <option value="cardiology">Dr. Sudhir Naik(Senior Consultant Obstetrician and Gynaecologist)</option>
                            <option value="neurology">Dr. Savita Naik(Senior Pediatrician and Neonatologist)</option>
                            
                          </select>
                          
                        
                          <span className="error_msg appointNameValid" id="subject_error" />
                       
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="form-group appoint__item date_field">
                          <input
                            type="text"
                            name="date"
                            data-toggle="datetimepicker2"
                            className="form-control"
                            placeholder="Select Date"
                            id="datepicker"
                          />
                          <span className="error_msg" id="date_error" />
                        </div>
                      </div>

                      <div className="col-lg-12 col-sm-12">
                        <div className="form-group appoint__item">
                          <textarea
                            name="message"
                            className="form-control custMessage"
                            rows={4}
                            placeholder="Message"
                            defaultValue={""}
                          />
                          <span className="error_msg custMessageValid" id="message_error" />
                        </div>
                      </div>
                      <div className="col-lg-12 col-sm-12">
                        <div className="form-group mailsendbtn mb-0 w-100">
                          <button
                            type="submit"
                            name="contactus"
                            className="buttn buttn__primary buttn__rounded buttn__block" onClick={formSubmit} defaultValue="Send Now"> 
                            Book Appointment
                          </button>
                          <div className="loading">
                            <img
                              className="img-fluid"
                              src="assets/images/ajax-loader.gif"
                              alt="loading"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  <div className="response-msg" />
                </div>
              </Fade>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="heading-subheading text-center reverse-heading-yes">
            <h4 className="subtitle">Treatments</h4>
            <h2 className="title">Provide Various Treatments</h2>
          </div>
          <div className="row">
            <Swiper
              navigation={true}
              breakpoints={{
                570: {
                  slidesPerView: 1,
                  spaceBetween: 100,
                },
                640: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 50,
                },
              }}
              modules={[Navigation]}
              className="mySwiper1"
            >
               {TreatmentData.map((elem) => {
              const { Slugs,  ServiceName  } =
                elem;
              return (
                <>
              <SwiperSlide>
                <div className="single-service-item">
                  <div className="img-holder">
                    <img src={iui} alt="best iui center in malad" />
                    <div className="content">
                      <div className="text-holder text-center">
                        <div className="inner">
                          <div className="inner-content">
                            <div className="icon-box">
                              <span className="flaticon-medical" />
                            </div>
                            <h3>{ServiceName}</h3>
                             <Link to={`${Slugs}`}>
                              View More
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="text-holder-1 text-center">
                        <div className="inner">
                          <div className="inner-content">
                            <div className="icon-box">
                              <span className="flaticon-medical" />
                            </div>
                            <h3>IUI(intra uterine Insemination)</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            
              </>
              );
            })}
            </Swiper>
          </div>
        </div>
      </section>

      {/* -----------------------process section--------------------------------- */}

      <section className="process pt-lg-5 pt-2 pb-lg-5 pb-2">
        <div className="container">
          <Zoom left cascade>
            <div className="heading-subheading heading__title text-center reverse-heading-yes">
              <h4 className="sub-title">Our Easy Solution</h4>
              <h2 className="element-title text-light">
                Follow our easy steps to get your proper solution
              </h2>
            </div>
          </Zoom>
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
              <article className="process__item">
                <div className="process__inner">
                  <div className="process__icon">
                    <i className="fa fa-address-book" />
                    
                  </div>
                  <div className="process__content">
                    <Fade left cascade>
                      <span className="process__step">Step 01</span>
                      <h3 className="process__title">
                        <a href="javascript:void(0)">
                          Call Doctor
                        </a>
                      </h3>
                    </Fade>
                  </div>
                </div>
              </article>
            </div>

            {/* Slide2 */}

            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
              <article className="process__item">
                <div className="process__inner">
                  <div className="process__icon">
                    <i className="fa fa-user-md" />
                  </div>
                  <div className="process__content">
                    <Fade left cascade>
                      <span className="process__step">Step 02</span>
                      <h3 className="process__title">
                        <a href="javascript:void(0)">Schedule Appointment</a>
                      </h3>
                    </Fade>
                  </div>
                </div>
              </article>
            </div>

            {/* Slide3 */}

            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
              <article className="process__item">
                <div className="process__inner">
                  <div className="process__icon">
                    <i className="fa fa-phone" />
                  </div>
                  <div className="process__content">
                    <Fade left cascade>
                      <span className="process__step">Step 03</span>
                      <h3 className="process__title">
                        <a href="javascript:void(0)">Consult Doctor</a>
                      </h3>
                    </Fade>
                  </div>
                </div>
              </article>
            </div>

            {/* Slide4 */}

            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
              <article className="process__item">
                <div className="process__inner">
                  <div className="process__icon">
                    <i className="fa fa-medkit" />
                  </div>
                  <div className="process__content">
                    <Fade left cascade>
                      <span className="process__step">Step 04</span>
                      <h3 className="process__title">
                        <a href="javascript:void(0)">Get Treatment</a>
                      </h3>
                    </Fade>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Home;
